<template>
    <div class="addition-fields" v-if="props.fields?.length">
        <div v-for="item in props.fields"
            :key="item.name"
        >
            <div>
                <Toggler
                    v-if="!item.required"
                    @onClick="item.checked = !item.checked"
                    :name="item.name"
                    :inline="true"
                    class="reverse"
                    :checked="item.checked" />

                <span v-else>{{ item.name }}</span>
            </div>

            <DateField
                v-if="item.type === 'period' && item.checked"
                :autoApply="true"
                :range="true"
                :text-input="true"
                :enableTimePicker="!!item.enableTimePicker"
                :placeholder="item.placeholder || 'dd.MM.yyyy - dd.MM.yyyy'"
                :format="item.format || 'dd.MM.yyyy'"
                v-model="item.values"
                class="light"
            />
        </div>
    </div>
</template>

<script setup>
    import { reactive } from 'vue';
    import { useI18n } from 'vue-i18n';
    import Button from '🔗/components/ui/Button.vue';
    import Toggler from '🔗/components/ui/Toggler.vue';
    import DateField from '🔗/components/ui/DateField.vue';

    const props = defineProps({
        fields: { type: [Array, null], default: () => ([]) }
    });

    const validate = () => {
        if (props.fields?.length) {
            if (!props.fields.every(item => !item.validate || item.validate(item))) {
                return;
            };
        }

        return true;
    };

    defineExpose({
        validate
    })
</script>

<style scoped lang="scss">
.addition-fields {
    display: flex;
    flex-direction: column;
    & > div {
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > div {
            display: flex;
            flex-direction: row;
            gap: 8px;
            min-height: 36px;
            align-items: center;

            & > span {
                font: var(--font-body-1);
                color: var(--dark-500);
            }

            & > div {
                flex: 1;
            }
        }

    }
}
</style>
